import * as ko from "knockout";
import Bao from "./../services/bao-service";
import NodeViewModel from "./../factories/node-view-model";
import ChildTabViewModel from "./../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../factories/tab-page";
import BaoDialogViewModel from "./../factories/bao-dialog";
import baoRouter from "./../services/bao-router";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../bindings/bao-searcher";
import "./../bindings/bao-toolbar2";
import "./../bindings/sorting";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
function TicketEvaluationTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(this, tabPage, parent);
    tabPage.ViewModel(self);
    self.Bao = Bao;
    self.Ticket = parent;
    self.init = function () {
        return self.PerformRefresh();
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.PerformRefresh();
    });
    self.PageSize = ko.observable(20);
    self.PageSize.subscribe(function () {
        if (self.PageIndex() == 0) {
            self.PerformRefresh();
        }
        else {
            self.PageIndex(0);
        }
    });
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.PerformRefresh();
    });
    self.EvaluationCollection = ko.observableArray([]);
    self.SelectRow = function (item) {
        self.SelectedEvaluationRow(item);
        return true;
    };
    self.SelectedEvaluationRow = ko.observable({});
    self.SelectedEvaluationRow.subscribe(function () {
        if (self.SelectedEvaluationRow() == null) {
            self.enableDisableButton("EditTicketEvaluation", false);
            self.enableDisableButton("DeleteTicketEvaluation", false);
        }
        else {
            self.enableDisableButton("EditTicketEvaluation", true);
            self.enableDisableButton("DeleteTicketEvaluation", Bao.Utils.String.IsNullOrWhitespace(self.SelectedEvaluationRow().CompleteDateJs));
        }
    });
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteTicketEvaluation");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddTicketEvaluation":
                self.ShowCreateEvaluationDialog(self.Ticket.TicketId());
                break;
            case "EditTicketEvaluation":
                if (self.SelectedEvaluationRow() != null) {
                    self.EditTicketEvaluation(self.SelectedEvaluationRow());
                }
                break;
            case "DeleteTicketEvaluation":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteTicketEvaluation(self.SelectedEvaluationRow());
                    }
                });
                break;
            case "RefreshTicketEvaluation":
                self.PerformRefresh();
                break;
        }
    };
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        return Bao.post("Ticket/GetTicketEvaluationCollection", JSON.stringify({
            ticketId: self.Ticket.TicketId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedEvaluationRow(null);
            self.TotalRows(0);
            self.EvaluationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.EvaluationCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.CreateEvaluation = function (folderStructureChecklistId, ticketId) {
        tabPage.IsLoading(true);
        return Bao.post("Ticket/CreateEvaluationByTicket", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            ticketId: ticketId
        }), function (result) {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            tabPage.IsLoading(false);
        });
    };
    self.DeleteTicketEvaluation = function (item) {
        Bao.post("Ticket/DeleteTicketEvaluation", JSON.stringify({
            ticketId: self.Ticket.TicketId(),
            evaluationId: ko.unwrap(item.EvaluationId)
        }), function () {
            self.PerformRefresh();
        });
    };
    self.EditTicketEvaluation = function (item) {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    };
    self.ShowCreateEvaluationDialog = function (ticketId) {
        window.baorequire(["ViewModels/Dialogs/CreateEvaluationDialog"], function (vm) {
            var dialog = new vm(tabPage, self);
            dialog.Show();
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == true) {
                    self.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), self.Ticket.TicketId());
                }
            });
        });
    };
    self.enableDisableButton = function (actionKey, enabled) { };
    self.Refresh = function () {
        var def = $.Deferred();
        self.PerformRefresh().then(function () {
            def.resolve();
        });
        return def.promise();
    };
    self.Save = function () { };
    self.loaded = function () {
        return self.Refresh();
    };
}
export default TicketEvaluationTabModel;